import { Spin } from 'antd';

import styles from 'assets/css/Design.module.css';

interface StateProps {
    children?: React.ReactNode;
}

const Fallback = ({ children }: StateProps) => {
    return (
        <Spin spinning={true} tip="Načítám aplikaci..." size="large" className={styles.Fallback}>
            {children}
        </Spin>
    )
}

export default Fallback;